// @flow

import { CareerActionTypes } from './actionTypes';
import { CareersMapper } from 'mappers/careers';
import { CommonMapper } from 'mappers/common';
import { get } from 'lodash';

const getJobPosts = verticalId => (dispatch, getState, { api }) => {
  dispatch({
    type: CareerActionTypes.CAREERS.FETCH,
    payload: {},
    test: api
      .post(`jobPosts.json`, { vertical_id: verticalId ? verticalId : '' })
      .then(res => {
        const response = get(res, 'data.data', {});
        const jobPosts = response.job_posts || [];
        const mediaPath = CommonMapper.extractMediaPath(response);
        dispatch({
          type: CareerActionTypes.CAREERS.SUCCESS,
          payload: CareersMapper.mapJobPosts(jobPosts, mediaPath),
        });
      })
      .catch(error => {
        dispatch({
          type: CareerActionTypes.CAREERS.FAILURE,
          error,
        });
      }),
  });
};

const getJobDetails = url_slug => (dispatch, getState, { api }) => {
  dispatch({
    type: CareerActionTypes.SPECIFICJOB.FETCH,
    payload: {},
    test: api
      .post(`getJobDetails.json`, { url_slug: url_slug })
      .then(res => {
        const response = get(res, 'data.data', {});
        const jobPosts = response.job_posts || [];
        const mediaPath = CommonMapper.extractMediaPath(response);
        dispatch({
          type: CareerActionTypes.SPECIFICJOB.SUCCESS,
          payload: CareersMapper.mapJobPosts(jobPosts, mediaPath),
        });
      })
      .catch(error => {
        dispatch({
          type: CareerActionTypes.SPECIFICJOB.FAILURE,
          error,
        });
      }),
  });
};

export const CareerActions = {
  getJobPosts,
  getJobDetails,
};
